import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import Buttons from "../../components/ui/button/Buttons";
import Select from "react-select";
import { decryptAESID } from "../../utils/Encryption";
import { useNavigate, useParams } from "react-router-dom";
import ModalGroupingTable from "./components/ModalGroupingTable";
import CostAllocation from "./components/CostAllocation";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyGetProductDetailsListByProductInformationIdQuery, useCostAlloctionBySGBPProducatInformationIdMutation, useLazyGetCertificateGroupingDetailsByIdQuery, useSendCertificateGroupingRequestForReviewMutation, useValidateCertificateNumberForAssignmentMutation, useSaveFinalCertificateAndCostAllocationMutation, useLazyGetCertificateGroupingDetailsForCommonByIdQuery, useSaveCertificateAndCostAllocationListMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import ToastService from "../../services/toastService/ToastService";
import { useDownloadCostAllocationDocMutation, useLazyDeleteCertificateCostAllocExcelUploadByGroupingIdQuery, useLazyGetCertificateGroupingDetailsForGWPConcreteByIdQuery, useLazyGetPeerReviewEvaluationDetailsByIdQuery, useSaveCertificateAndCostAllocationListForGWPConcreteMutation, useUploadCostAllocationMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import * as XLSX from "xlsx";
import { decryptAES } from "../../services/CryptoService";
import { saveAs } from "file-saver";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";

const errorSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
    "&:hover": {
      borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
    },
  }),
};
const tickOptions = [
  { label: "1 Tick", value: 1 },
  { label: "2 Ticks", value: 2 },
  { label: "3 Ticks", value: 3 },
  { label: "4 Ticks", value: 4 },
];
const CertificateGroupingListGWPConcrete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
   const appID = decryptAESID(id, false);
  const manualTickRowsRef = useRef(new Set());
  const firstRowOriginalRef = useRef(null);
  const { success, error } = SwalAlert();
  const [productList, setProductList] = useState([]);
  const [approverOptions, setApproverOptions] = useState([]);
  const [internalNotes, setInternalNotes] = useState("");
  const [approver, setApprover] = useState();
  const [peerReviewer, setPeerReviewer] = useState();
  const [costAllocationList, setCostAllocationList] = useState([]);
  const [isReview, setIsReview] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [formErrors, setFormErrors] = useState({ costAllocation: {}, peerReviewer: "", approver: "" });
  const [appNumberValues, setAppNumberValues] = useState({});

  const [getProductDetailsListByProductInformationId, { isLoading: productListLoading, isSuccess: productListSuccess, data: productListData }] = useLazyGetProductDetailsListByProductInformationIdQuery();
  const [GetCertificateGroupingDetailsForGWPConcrete, { isLoading: gwpConcreteDetailIsLoading, isSuccess: gwpConcreteDetailIsSuccess, data: gwpConcreteDetailData }] = useLazyGetCertificateGroupingDetailsForGWPConcreteByIdQuery();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [validateCertificateNumberForAssignment, { isLoading: checkCernumLoading }] = useValidateCertificateNumberForAssignmentMutation();
  const [saveCertificateAndCostAllocationList, { isLoading: saveCertificateLoading, isSuccess: saveCertificateSuccess, data: saveCertificateData }] = useSaveCertificateAndCostAllocationListMutation();
  const [sendCertificateGroupingForReview, { isLoading: sendCertificateGroupingForReviewLoading, isSuccess: sendCertificateGroupingForReviewSuccess, data: sendCertificateGroupingForReviewData }] = useSendCertificateGroupingRequestForReviewMutation();
  const [sendFinalCertificateAndCostAllocation, { data: sendFinalCertificateAndCostAllocationData }] = useSaveFinalCertificateAndCostAllocationMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [uploadCostAllocation, { isLoading: uploadCostAllocationLoading }] = useUploadCostAllocationMutation();
  const [saveCertificateAndCostAllocationListForGWPConcrete, { isLoading: saveGWPConcreteLoading, isSuccess: saveGWPConcreteSuccess, data: saveGWPConcreteData }] = useSaveCertificateAndCostAllocationListForGWPConcreteMutation();
  const [downloadDoc] = useDownloadCostAllocationDocMutation();
  const [deleteCertificateCostAllocExcelUpload] = useLazyDeleteCertificateCostAllocExcelUploadByGroupingIdQuery();
  const { addAuditLog } = useAddAuditLogForSGBPApplcation();


  useEffect(() => {
    const container = document.querySelector(".center-container");
    if (container) {
      container.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    if (saveGWPConcreteLoading && saveGWPConcreteSuccess && saveGWPConcreteData) {
      if (saveGWPConcreteLoading?.hasError) {
        ToastService.error(saveGWPConcreteLoading?.errorMessage);
      }
      else if (!isReview) {
        success("Certificate Grouping Request Updated Successfully!");
      }
      setIsReview(false);
    }
  }, [saveGWPConcreteLoading, saveGWPConcreteSuccess, saveGWPConcreteData])


  // Single source of truth for dropdown options — computed once per data change,
  // reused across every effect/handler instead of re-filtering repeatedly.
  const approverOptionsMemo = useMemo(() => productsAndServicesDropDownsData?.filter((item) => item.dropdownName === "Approver List")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData]);

  const itemCodeOptionsMemo = useMemo(() => productsAndServicesDropDownsData
    ?.filter((item) => item.dropdownName === "Items Codes")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData]
  );

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      productsAndServicesDropdown();
      getProductDetailsListByProductInformationId(editID);
      GetCertificateGroupingDetailsForGWPConcrete(editID);
      getPeerReviewEvaluationDetailsById(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setApproverOptions(approverOptionsMemo);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData, approverOptionsMemo]);

  useEffect(() => {
    if (!productListLoading && productListSuccess && productListData) {
      setProductList(productListData);
      const list = Array.isArray(productListData) ? productListData : productListData?.data || [];
      firstRowOriginalRef.current = list.length > 0 ? list[0].applicationNumber : null;

      //  try
      const initialApp = {};
      productListData?.forEach((item) => { initialApp[item.sgbpProductId] = item.applicationNumber ?? ""; });
      setAppNumberValues(initialApp);

    }
  }, [productListLoading, productListSuccess, productListData]);

  useEffect(() => {
    if (productList && productList.length > 0) {
      const editID = decryptAESID(id, false);
      const waitingForSavedData = editID > 0 && gwpConcreteDetailIsLoading;
      if (waitingForSavedData) return;
      const list = Array.isArray(productList) ? productList : productList?.data || [];
      setCostAllocationList((prevRows) =>
        buildCostAllocationRows(list, itemCodeOptionsMemo, prevRows)   // ✅ fix automatically apply thashe
      );
    }
  }, [productList, itemCodeOptionsMemo]);

  // get api 
  useEffect(() => {
    if (!gwpConcreteDetailIsLoading && gwpConcreteDetailIsSuccess && gwpConcreteDetailData && productListData) {
      const list = gwpConcreteDetailData?.getCertificateAndCostAllocationList;
      setIsApprove(gwpConcreteDetailData?.statusId == 8);
      const peerReviewerOption = approverOptionsMemo?.find((item) => item.value === gwpConcreteDetailData?.peerReviewerId);
      const approverOption = approverOptionsMemo?.find((item) => item.value === gwpConcreteDetailData?.approverId);
      setPeerReviewer(peerReviewerOption || null);
      setApprover(approverOption || null);
      setInternalNotes(gwpConcreteDetailData?.commentFromCaseOfficer || "");
      const rows = buildCostAllocationRows(productListData, itemCodeOptionsMemo);
      if (list?.length > 0) {
        rows.forEach((row) => {
          let certificateNumber = row.label;
          let prefix = 0;
          const lastSlashIndex = row.label.lastIndexOf("/");
          if (lastSlashIndex !== -1) {
            certificateNumber = row.label.substring(0, lastSlashIndex);
            prefix = row.label.substring(lastSlashIndex + 1);
          }
          const existingAllocation = list.find((x) => {
            const [xCertificateNumber, xPrefix = 0] = x.certificateNumber.split("/");
            return (xCertificateNumber === certificateNumber && Number(xPrefix) === Number(prefix || 0));
          });
          row.value = existingAllocation ? itemCodeOptionsMemo?.find((i) => i.value === existingAllocation.itemCode) ?? null : null;
          row.tickValue = existingAllocation ? tickOptions?.find((t) => t.value === existingAllocation.tickRating) ?? null : null;
          row.sgbpCertificateGroupingId = existingAllocation ? existingAllocation.sgbpCertificateGroupingId : 0;
          row.certificateFileName = existingAllocation ? (existingAllocation.costAllocFileName ?? existingAllocation.fileName ?? null) : null;
          row.certificateFilePath = existingAllocation ? (existingAllocation.costAllocFilePath ?? existingAllocation.filePath ?? null) : null;
          row.finalCertificateAndCostAllocationId = existingAllocation ? existingAllocation.finalCertificateAndCostAllocationId : 0;
          manualTickRowsRef.current.add(row.id);
        });
      }
      setCostAllocationList(rows);
    }
  }, [gwpConcreteDetailIsLoading, gwpConcreteDetailIsSuccess, gwpConcreteDetailData, productListData, itemCodeOptionsMemo, approverOptionsMemo]);

  useEffect(() => {
    if (!saveCertificateLoading && saveCertificateData && saveCertificateSuccess) {
      if (saveCertificateData?.hasError) {
        ToastService.error(saveCertificateData?.errorMessage);
      }
      else if (!isReview) {
        success("Certificate Grouping Request Updated Successfully!");
      }
      setIsReview(false);
    }
  }, [saveCertificateLoading, saveCertificateData, saveCertificateSuccess]);

  useEffect(() => {
    if (!sendCertificateGroupingForReviewLoading && sendCertificateGroupingForReviewSuccess && sendCertificateGroupingForReviewData) {
      if (!sendCertificateGroupingForReviewData.hasError) {
        ToastService.success("Review Request sent successfully");
        addAuditLog({ SGBPSApplicationId: appID, AuditLogDescription: "SGBP Application Send For Review ", TriggredTimeStatusId: gwpConcreteDetailData?.statusId });
        handleFinalCostAllocation();
        handleSave();
        handleBack();
      } else {
        ToastService.error(sendCertificateGroupingForReviewData.errorMessage);
      }
    }
  }, [sendCertificateGroupingForReviewLoading, sendCertificateGroupingForReviewSuccess, sendCertificateGroupingForReviewData]);


  const handleCertificateFileDownload = useCallback(
    async (row) => {
      if (isApprove) return;
      if (!row?.certificateFileName || !row?.certificateFilePath) {
        ToastService.error("No file available to download.");
        return;
      }
      try {
        const req = {
          SGBPCertificateGroupingId: row?.sgbpCertificateGroupingId,
          Type: row?.certificateFileName.split(".").pop(),
          Path: row?.certificateFilePath,
        };
        const filePath = row?.certificateFilePath;
        const fileExt = filePath?.match(/\.[^.]+$/)?.[0];
        const blob = await downloadDoc(req).unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filePath?.replace(/^UploadCostAllocationDoc[\\/]/i, "")?.split(/[\\/]/).pop() || `resource${fileExt || ""}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        ToastService.error("File not found");
      }
    },
    [downloadDoc, isApprove]
  );

  // const buildCostAllocationRows = (list, itemCodes, existingRows = []) => {
  //   const uniqueMap = new Map();
  //   list.forEach((item) => {
  //     const certNumber = item.applicationNumber;
  //     const certPrefix = item.certPrefix;
  //     const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;
  //     if (!uniqueMap.has(key)) {
  //       uniqueMap.set(key, true);
  //     }
  //   });

  //   return Array.from(uniqueMap.keys()).map((label, index) => {
  //     const existingExact = existingRows?.find((row) => row.label === label);
  //     const existingByIndex = existingRows?.[index];

  //     return {
  //       id: index + 1,
  //       label,
  //       options: itemCodes,
  //       value: existingExact ? existingExact.value : null,
  //       tickValue: existingExact ? existingExact.tickValue : null, // <-- added
  //       sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? existingByIndex?.sgbpCertificateGroupingId ?? 0,
  //       finalCertificateAndCostAllocationId: existingExact?.finalCertificateAndCostAllocationId ?? existingByIndex?.finalCertificateAndCostAllocationId ?? 0,
  //       certificateFileName: existingExact?.certificateFileName ?? existingByIndex?.certificateFileName ?? null,
  //       certificateFilePath: existingExact?.certificateFilePath ?? existingByIndex?.certificateFilePath ?? null,
  //       tickOptions: tickOptions
  //     };
  //   });
  // };

  const parseRating = (rating) => {
    const n = Number(rating);
    return rating !== undefined && rating !== null && rating !== "" && !Number.isNaN(n)
      ? n
      : null; // gracefully handle null/undefined/empty/invalid
  };


  const computeMinRatingMap = (list) => {
    const groupMap = new Map();
    (list || []).forEach((item) => {
      const certNumber = item?.applicationNumber;
      const certPrefix = item?.certPrefix;
      if (!certNumber) return; // guard against null/undefined response rows
      const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;

      const rating = parseRating(item?.rating);
      if (!groupMap.has(key)) {
        groupMap.set(key, rating);
      } else if (rating !== null) {
        const currentMin = groupMap.get(key);
        groupMap.set(key, currentMin === null ? rating : Math.min(currentMin, rating));
      }
    });
    return groupMap;
  };

  const buildCostAllocationRows = (list, itemCodes, existingRows = []) => {
    const uniqueMap = new Map();
    list.forEach((item) => {
      const certNumber = item.applicationNumber;
      const certPrefix = item.certPrefix;
      const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
      }
    });

    const minRatingMap = computeMinRatingMap(list);

    return Array.from(uniqueMap.keys()).map((label, index) => {
      // const existingExact = existingRows?.find((row) => row.label === label);
      const existingExact = existingRows?.find((row) => row.label === label);
      const existingByIndex = existingRows?.[index];
      const rowId = index + 1;

      const minRating = minRatingMap.get(label) ?? null;
      const defaultTick = tickOptions.find((t) => t.value === minRating) ?? null;

      const isManual = manualTickRowsRef.current.has(rowId);
      const tickValue = isManual && existingExact
        ? existingExact.tickValue
        : defaultTick;

      return {
        id: rowId,
        label,
        options: itemCodes,
        value: existingExact ? existingExact.value : null,
        // tickValue: existingExact ? existingExact.tickValue : null,
        // sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? 0,
        // finalCertificateAndCostAllocationId: existingExact?.finalCertificateAndCostAllocationId ?? 0,
        tickValue,
        sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? existingByIndex?.sgbpCertificateGroupingId ?? 0,
        finalCertificateAndCostAllocationId: existingExact?.finalCertificateAndCostAllocationId ?? existingByIndex?.finalCertificateAndCostAllocationId ?? 0,
        certificateFileName: existingExact?.certificateFileName ?? null,
        certificateFilePath: existingExact?.certificateFilePath ?? null,
        tickOptions: tickOptions
      };
    });
  };

  const handleCostAllocationChange = useCallback((rowId, selectedOption) => {
    setCostAllocationList((prevRows) =>
      prevRows.map((row) => (row.id === rowId ? { ...row, value: selectedOption ?? null } : row))
    );
    setFormErrors((prev) => {
      if (!prev.costAllocation[rowId]?.itemCode) return prev;
      const nextRow = { ...prev.costAllocation[rowId] };
      delete nextRow.itemCode;
      const nextCostAllocation = { ...prev.costAllocation };
      if (Object.keys(nextRow).length > 0) {
        nextCostAllocation[rowId] = nextRow;
      } else {
        delete nextCostAllocation[rowId];
      }
      return { ...prev, costAllocation: nextCostAllocation };
    });
  }, []);

  const handleTickRatingChange = useCallback((rowId, selectedOption) => {
    setCostAllocationList((prevRows) =>
      prevRows.map((row) => (row.id === rowId ? { ...row, tickValue: selectedOption ?? null } : row))
    );
    setFormErrors((prev) => {
      if (!prev.costAllocation[rowId]?.tickRating) return prev;
      const nextRow = { ...prev.costAllocation[rowId] };
      delete nextRow.tickRating;
      const nextCostAllocation = { ...prev.costAllocation };
      if (Object.keys(nextRow).length > 0) {
        nextCostAllocation[rowId] = nextRow;
      } else {
        delete nextCostAllocation[rowId];
      }
      return { ...prev, costAllocation: nextCostAllocation };
    });
  }, []);

  const handleCertificateFileUpload = useCallback((rowId, file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        if (!jsonData || jsonData.length === 0) {
          ToastService.error("The uploaded file has no records. Please add data and try again.");
          return;
        }

        if (!jsonData || jsonData.length === 0) {
          ToastService.error("Uploaded file is empty or invalid.");
          return;
        }

        const firstRow = jsonData[0] || {};
        const snKey = Object.keys(firstRow).find(
          (key) => key.replace(/[\s\u00A0]+/g, "").toUpperCase() === "S/N"
        );

        if (!snKey) {
          ToastService.error('Column "S/N" not found in the uploaded file.');
          return;
        }

        const snValues = jsonData
          .map((row) => row[snKey])
          .filter((val) => val !== undefined && val !== null && val !== "");

        if (snValues.length === 0) {
          ToastService.error('No values found under "S/N" column.');
          return;
        }
        // Duplicate check
        const seen = new Set();
        const duplicates = new Set();
        snValues.forEach((val) => {
          const normalized = String(val).trim().toLowerCase();
          if (seen.has(normalized)) duplicates.add(val);
          else seen.add(normalized);
        });

        if (duplicates.size > 0) {
          ToastService.error(
            `Duplicate S/N found in uploaded file: ${Array.from(duplicates).join(", ")}`
          );
          return;
        }
        const uploadedRecords = jsonData.map((row) => ({
          SGBPCertificateGroupingId: 0, // new record, backend assign this
          MixCode: String(row["Mix Code"] ?? "").trim(),
          ComprehensiveStrengthClass: String(row["Comprehensive Strength Class"] ?? "").trim(),
          SlumpClass: String(row["Slump Class"] ?? "").trim(),
          OPCReplacement: String(row["OPC Replacement"] ?? "").trim(),
          GWP_A1_A3: String(row["GWP (A1-A3)"] ?? "").trim(),
        }));

        const formData = new FormData();
        formData.append("File", file);
        formData.append("StoragePath", "UploadCostAllocationDoc");

        const rData = await uploadCostAllocation(formData).unwrap();
        let response = decryptAES(rData?.responseData);
        setCostAllocationList((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId
              ? {
                ...row,
                certificateFile: file,
                certificateFileName: response?.fileName ?? file.name,
                certificateFilePath: response?.filePath ?? null,
                uploadedRecords, // for save payload 
              }
              : row
          )
        );

        setFormErrors((prev) => {
          if (!prev.costAllocation[rowId]?.file) return prev;
          const nextRow = { ...prev.costAllocation[rowId] };
          delete nextRow.file;
          const nextCostAllocation = { ...prev.costAllocation };
          if (Object.keys(nextRow).length > 0) nextCostAllocation[rowId] = nextRow;
          else delete nextCostAllocation[rowId];
          return { ...prev, costAllocation: nextCostAllocation };
        });

        ToastService.success("File uploaded successfully!");
      } catch (err) {
        console.error(err);
        ToastService.error("Failed to upload the file. Please try again.");
      }
    };

    reader.onerror = () => {
      ToastService.error("Error reading the file.");
    };

    reader.readAsArrayBuffer(file);
  }, [uploadCostAllocation]);

  const handleCertificateFileDelete = useCallback(
    async (rowId) => {
      const row = costAllocationList.find((r) => r.id === rowId);
      if (!row?.sgbpCertificateGroupingId) {
        setCostAllocationList((prevRows) =>
          prevRows.map((r) => r.id === rowId ? { ...r, certificateFile: null, certificateFileName: null, certificateFilePath: null, uploadedRecords: null, } : r
          )
        );
        return;
      }
      try {
        const response = await deleteCertificateCostAllocExcelUpload(row.sgbpCertificateGroupingId).unwrap();
        if (response?.hasError) {
          ToastService.error(response.errorMessage || "Failed to delete the file.");
          return;
        }
        setCostAllocationList((prevRows) =>
          prevRows.map((r) =>
            r.id === rowId
              ? {
                ...r, certificateFile: null, certificateFileName: null, certificateFilePath: null,
                uploadedRecords: null,
              }
              : r
          )
        );
        ToastService.success("File deleted successfully!");
      } catch (err) {
        console.error("Delete failed:", err);
        ToastService.error("Failed to delete the file. Please try again.");
      }
    }, [costAllocationList, deleteCertificateCostAllocExcelUpload]);

  const parseApplicationNumber = (value) => {
    const str = String(value ?? "");
    const match = str.match(/^([A-Za-z]+)(\d+)$/);
    if (!match) return null;
    const [, prefix, digitsPart] = match;
    return { prefix, number: parseInt(digitsPart, 10), width: digitsPart.length, };
  };
  const validateApplicationNumber = (referenceValue, newValue, apiFlage, isExisted) => {
    const referenceParsed = parseApplicationNumber(referenceValue);
    const newParsed = parseApplicationNumber(newValue);

    if (!referenceParsed || !newParsed) {
      ToastService.error("Invalid application number format.");
      return false;
    }

    if (referenceParsed.prefix !== newParsed.prefix) {
      ToastService.error("Prefix cannot be changed.");
      return false;
    }

    const diff = newParsed.number - referenceParsed.number;
    const expectedWidthForNewNumber = String(newParsed.number).length;
    const widthGrewNaturally =
      newParsed.width === Math.max(referenceParsed.width, expectedWidthForNewNumber) &&
      newParsed.width >= referenceParsed.width;

    if (!widthGrewNaturally) {
      ToastService.error("Invalid number format — digit padding is incorrect.");
      return false;
    }

    let isRecordExisted = productListData?.filter((item) => item.applicationNumber == newValue)

    // if (diff === 0 || diff === 1) return true; // same as reference, or +1
    if (diff === 0) return true; // same as reference, or +1
    if (diff === 1) {
      if (isExisted) {
        if (isRecordExisted.length > 0) {
          return true
        } else {
          return false
        }
      }
      return true
    }
    if (diff < 0) {
      ToastService.error("This number cannot be decreased.");
      return false;
    }
    if (diff > 0) {
      if (!apiFlage) {
        return true
      }
    }

    ToastService.error("Please increase by 1 at a time — the number cannot skip.");
    return false;
  };
  const handleAppNumberChange = useCallback((id, value) => {
    setAppNumberValues((prev) => ({ ...prev, [id]: value }));
  }, []);

  const handleApplicationNumberBlur = useCallback(async (id, value) => {
    try {
      const response = await validateCertificateNumberForAssignment({ CertificateNumber: value, }).unwrap();
      let { isCertificateNumberAssigned, nextCertificateSequenceNumber, isExisted } = response;
      const newParsed = parseApplicationNumber(nextCertificateSequenceNumber);
      const index = productList.findIndex((item) => item.sgbpProductId === id);
      const oldValue = productListData?.filter((item) => item.sgbpProductId === id);
      if (value == oldValue[0]?.applicationNumber) {
        // return true;
         setProductList((prev) =>
          prev.map((item) => (item.sgbpProductId === id ? { ...item, applicationNumber: value } : item))
        );
        return true;
      }
      if (index === -1) return false;

      const current = productList[index];
      const ownParsed = parseApplicationNumber(current.applicationNumber);
      if (!ownParsed) {
        ToastService.error("Invalid application number format.");
        return false;
      }
      if (isExisted) {
        ToastService.info(`The next Certificate Sequence Number is: ${nextCertificateSequenceNumber}`);
        return false;
      }
      const referenceValue = index === 0 ? (firstRowOriginalRef.current ?? current.applicationNumber) : productList[index - 1].applicationNumber;
      const isValid = validateApplicationNumber(referenceValue, value, isCertificateNumberAssigned, isExisted);
      if (!isValid) return false;
      // ---- API call on blur ----
      if (response?.hasError) {
        ToastService.error(response.errorMessage || "Certificate number already assigned or invalid.");
        return false;
      }
    } catch (err) {
      console.log(err);
      ToastService.error("Something went wrong while validating certificate number.");
      return false;
    }
    setProductList((prev) =>
      prev.map((item) => (item.sgbpProductId === id ? { ...item, applicationNumber: value } : item))
    );
    return true;
  }, [productList, validateCertificateNumberForAssignment]);

  // const handleProductChange = useCallback((id, field, value) => {
  //   setProductList((prev) =>
  //     prev.map((item) => (item.sgbpProductId === id ? { ...item, [field]: value } : item))
  //   );
  // }, []);

  // handleProductChange ma, field === "certPrefix" hoy tyare
  const handleProductChange = useCallback((id, field, value) => {
    setProductList((prev) =>
      prev.map((item) => (item.sgbpProductId === id ? { ...item, [field]: value } : item))
    );

    if (field === "certPrefix") {
      const relatedProduct = productList.find((p) => p.sgbpProductId === id);
      const oldKey = relatedProduct?.certPrefix
        ? `${relatedProduct.applicationNumber}/${relatedProduct.certPrefix}`
        : relatedProduct?.applicationNumber;
      const affectedRow = costAllocationList.find((row) => row.label === oldKey);
      // if (affectedRow?.sgbpCertificateGroupingId) {
      //   deleteCertificateCostAllocExcelUpload(affectedRow.sgbpCertificateGroupingId);
      // }
    }
    // ===== END CHANGE =====
  }, [productList, costAllocationList, deleteCertificateCostAllocExcelUpload]);

  const validateForm = useCallback(() => {
    const errors = { costAllocation: {}, peerReviewer: "", approver: "" };
    let firstErrorMessage = "";
    costAllocationList.forEach((row) => {
      const rowError = {};
      if (!row.value) {
        rowError.itemCode = "Item Code is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please select Item Code for "${row.label}".`;
      }
      if (!row.tickValue) {
        rowError.tickRating = "Tick Rating is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please select Tick Rating for "${row.label}".`;
      }
      if (!row.certificateFileName) {
        rowError.file = "Certificate file is required.";
        if (!firstErrorMessage) firstErrorMessage = `Please upload Certificate file for "${row.label}".`;
      }
      if (Object.keys(rowError).length > 0) {
        errors.costAllocation[row.id] = rowError;
      }
    });
    if (!peerReviewer) {
      errors.peerReviewer = "Peer Reviewer is required.";
      if (!firstErrorMessage) firstErrorMessage = "Please select Peer Reviewer.";
    }
    if (!approver) {
      errors.approver = "Approver is required.";
      if (!firstErrorMessage) firstErrorMessage = "Please select Approver.";
    }
    setFormErrors(errors);
    if (firstErrorMessage) {
      error(firstErrorMessage);
      return false;
    }
    return true;
  }, [costAllocationList, peerReviewer, approver]);

  // submit
  const handleSave = useCallback(async () => {
    if (!validateForm()) return;

    const applicationId = decryptAESID(id?.toString(), false);

    const payload = {
      Comments: internalNotes,
      PeerReviewerId: peerReviewer?.value ?? null,
      ApproverId: approver?.value ?? null,
      SGBPSApplicationId: applicationId,

      CertificateAndCostAllocationListForGWPConcreteRequest: costAllocationList.map((row) => {
        const [certificateNumber, certPrefix] = row.label.split("/");

        return {
          SGBPSApplicationId: applicationId,
          ItemCode: row.value?.value ?? null,
          CertificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          TickRating: row.tickValue?.value ?? null,
          CostAllocFileName: row.certificateFileName ?? null,
          CostAllocFilePath: row.certificateFilePath ?? null,
          UploadCertificateCostAllocationRequest: row.uploadedRecords ?? [],
        };
      }),

      ModelGroupingListForGWPConcreteRequest: productList.map(
        ({ rating, certPrefix, sgbpProductId, applicationNumber }) => ({
          SgbpProductId: sgbpProductId,
          Rating: rating !== undefined && rating !== null && rating !== "" ? Number(rating) : null,
          CertPrefix: Number(certPrefix) === 0 ? null : Number(certPrefix),
          CertificateNumber: String(applicationNumber),
        })
      ),
    };
    try {
      const response = await saveCertificateAndCostAllocationListForGWPConcrete(payload).unwrap();

      if (response?.hasError) {
        ToastService.error(response.errorMessage || "Something went wrong while saving.");
      } else {
        success("Certificate Grouping Request Updated Successfully!");
      }
    } catch (err) {
      console.error(err);
      ToastService.error("Failed to save. Please try again.");
    }
  }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList, saveCertificateAndCostAllocationListForGWPConcrete,]);

  const handleFinalCostAllocation = useCallback(() => {
    if (!validateForm()) return;
    const applicationId = decryptAESID(id?.toString(), false);


    const req = {
      sGBPSApplicationId: applicationId,
      finalCostAllocationRequestListRequest: costAllocationList.map((row) => {
        const [certificateNumber, certPrefix] = row.label.split("/");

        return {
          sGBPSApplicationId: decryptAESID(id, false) ?? 0,
          finalCertificateAndCostAllocationId: row?.finalCertificateAndCostAllocationId ?? 0,
          itemCode: row.value?.value,
          certificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          tickRating: row.tickValue?.value,
          costAllocFilePath: row?.certificateFilePath,
          costAllocFileName: row?.certificateFileName
        };
      })
    };
    sendFinalCertificateAndCostAllocation(req);
  }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList]);

  const handleReviewRequest = useCallback(() => {
    if (!validateForm()) return;
    setIsReview(true);
    const req = { sGBPProductInformationId: decryptAESID(id) };
    sendCertificateGroupingForReview(req);
  }, [validateForm, id, sendCertificateGroupingForReview]);

  const handleBack = () => {
    navigate("/viewApplicationTaskList");
  };

  const handlePeerReviewerChange = useCallback((selected) => {
    setPeerReviewer(selected);
    setFormErrors((prev) => (prev.peerReviewer ? { ...prev, peerReviewer: "" } : prev));
  }, []);

  const handleApproverChange = useCallback((selected) => {
    setApprover(selected);
    setFormErrors((prev) => (prev.approver ? { ...prev, approver: "" } : prev));
  }, []);

  const peerReviewerOptions = useMemo(
    () => approverOptions.filter((opt) => opt.value !== approver?.value),
    [approverOptions, approver]
  );

  const approverSelectOptions = useMemo(
    () => approverOptions.filter((opt) => opt.value !== peerReviewer?.value),
    [approverOptions, peerReviewer]
  );
  const isPageLoading = productsAndServicesDropDownsLoading || productListLoading || gwpConcreteDetailIsLoading;

  return (
    <div className="certificate-grouping-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">

          {/* Model Grouping Section */}
          <div className="table-title mt-2">
            <h3>Model Grouping</h3>
          </div>
          <ModalGroupingTable
            data={productList}
            onChange={handleProductChange}
            onApplicationNumberBlur={handleApplicationNumberBlur}
            isDisabled={isApprove}
          />
          {/* Certificate and Cost Allocation Section */}
          <CostAllocation
            rows={costAllocationList}
            onChange={handleCostAllocationChange}
            onTickChange={handleTickRatingChange}
            onFileUpload={handleCertificateFileUpload}
            onFileDelete={handleCertificateFileDelete}
            onFileDownload={handleCertificateFileDownload}
            errors={formErrors.costAllocation}
            isDisabled={isApprove}
          />
          {/* Internal Notes Section */}
          <div className="table-title mt-5 mb-4">
            <h3>Internal Notes</h3>
          </div>
          <div className="mt-2">
            <label className="form-label">Comments from Case Officer</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={internalNotes}
              onChange={(e) => setInternalNotes(e.target.value)}
              disabled={isApprove}
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Peer Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment}
              maxLength={200}
              disabled
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Approver Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              disabled
              value={getPeerReviewEvaluationDetailsByIdData?.finalApproverComment}
            ></textarea>
          </div>


          {/* Assign to Section */}
          <div className="table-title mt-5 mb-4">
            <h3>Assign to</h3>
          </div>
          <div className="dropdown-select-wrapper">
            <div className="d-flex align-items-center mb-4">
              <label className="form-label mb-0 w-20">Peer Reviewer</label>
              <div style={{ flex: 1 }}>
                <Select
                  className="custom-checkbox-select"
                  value={peerReviewer}
                  options={peerReviewerOptions}
                  onChange={handlePeerReviewerChange}
                  isDisabled={isApprove}
                />
                {formErrors.peerReviewer && (
                  <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                    {formErrors.peerReviewer}
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center">
              <label className="form-label mb-0 w-20">Approver</label>
              <div style={{ flex: 1 }}>
                <Select
                  className="custom-checkbox-select"
                  value={approver}
                  onChange={handleApproverChange}
                  options={approverSelectOptions}
                  isDisabled={isApprove}
                />
                {formErrors.approver && (
                  <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                    {formErrors.approver}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              onClick={handleBack}
            />

            <div className="d-flex gap-3">
              <Buttons
                buttonText="Save"
                buttonTypeClassName="search-btn"
                onClick={handleSave}
                isLoading={!isReview && saveGWPConcreteLoading}
                isDisable={saveGWPConcreteLoading || isApprove}
              />
              {isApprove ? <Buttons
                buttonText={"Approve"}
                buttonTypeClassName="success-btn"
              /> :
                <Buttons
                  buttonText={"Request for Review"}
                  buttonTypeClassName="success-btn"
                  onClick={handleReviewRequest}
                  isLoading={sendCertificateGroupingForReviewLoading}
                  isDisable={sendCertificateGroupingForReviewLoading}
                />}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CertificateGroupingListGWPConcrete;
